import { Bell } from 'lucide-react';
import { useAppState } from '../../context/AppStateContext';
import { useAuth } from '../../context/AuthContext';
import { useResponsive } from '../../hooks/useResponsive';

function getTimeOfDay() {
  const hour = new Date().getHours();
  if (hour >= 0 && hour < 12) {
    return 'morning';
  } else if (hour >= 12 && hour < 17) {
    return 'day';
  } else {
    return 'evening';
  }
}

function getGreeting(timeOfDay) {
  switch (timeOfDay) {
    case 'morning':
      return 'Good morning';
    case 'day':
      return 'Good day';
    case 'evening':
      return 'Good evening';
    default:
      return 'Hello';
  }
}

export default function GlobalHeader() {
  const { setShowNotifications, unreadCount, profileForm } = useAppState();
  const { user } = useAuth();
  const { isDesktop } = useResponsive();

  // Only show on desktop (mobile has header in each tab)
  if (!isDesktop) return null;

  const timeOfDay = getTimeOfDay();
  const greeting = getGreeting(timeOfDay);
  const firstName = user?.first_name || profileForm?.firstName || 'there';

  return (
    <header className="sticky top-0 z-20 bg-white border-b border-gray-100">
      <div className="flex items-center justify-between px-6 py-4">
        <h1 className="text-xl font-bold text-gray-900">
          {greeting}, {firstName}
        </h1>

        <button
          onClick={() => setShowNotifications(true)}
          className="relative p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors"
        >
          <Bell size={24} />
          {unreadCount > 0 && (
            <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-green-500 rounded-full" />
          )}
        </button>
      </div>
    </header>
  );
}
